<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/language']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'language_common_name' | translate"></nz-statistic>
    </a>
</nz-card>